<template>
  <div class="asset-user">
    <div class="index-view-top">
      <van-icon
        @click="toBack"
        name="arrow-left"
        size="28"
        color="#ffffff"
      />
      <div class="title">{{ $t("head.asset") }}</div>
      <van-icon
        style="opacity: 0"
        name="ellipsis"
        size="28"
        color="#ffffff"
      />
    </div>
    <div class="asset-main">
      <div class="main-input">
        <van-password-input
          :value="passwordValue"
          :gutter="10"
          :focused="showKeyboard"
          @focus="showKeyboard = true"
        />
        <van-number-keyboard
          maxlength="6"
          v-model="passwordValue"
          :show="showKeyboard"
          @blur="showKeyboard = false"
          @input="onInput"
        />
      </div>
      <div class="tips">{{ $t("asset.password") }}</div>
      <div
        class="nowLogin"
        @click="setPayPassword"
      >
        <div>
          <p>{{ $t("asset.confirm") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { payPwd } from '@/utils/request'
export default {
  data() {
    return {
      passwordValue: '',
      showKeyboard: true
    }
  },
  mounted() {},
  methods: {
    onInput(e) {
      if (this.passwordValue == '') {
        this.passwordValue = e.toString()
      }
      this.passwordValue += e.toString()
    },
    setPayPassword() {
      if (this.passwordValue.length == 6 && Number(this.passwordValue)) {
        payPwd({
          oldPassword: this.passwordValue
        }).then(res => {
          if (res.code == '200') {
            this.$toast.success(this.$t('prompt.Set_success'))
            setTimeout(() => {
              this.$router.go('-1')
            }, 500)
          } else {
            this.$toast.success(res.msg)
          }
        })
      } else {
        this.$toast.success(this.$t('asset.password'))
      }
    },
    toBack() {
      this.$router.go('-1')
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.van-password-input__security li {
  width: 2.75rem;
  height: 2.75rem;
  background: rgba(255, 196, 0, 0.1);
  border-radius: 0.3125rem;
}

/deep/.van-password-input__security i {
  background-color: #ffffff;
}
/deep/.van-password-input__cursor {
  background-color: #fff;
}

.asset-user {
  width: 100vw;
  height: 100vh;
  background: #0c0b0b;

  .asset-main {
    padding: 0 0.9375rem;

    .main-input {
      padding-top: 3.75rem;
    }

    .tips {
      font-size: 0.75rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #999999;
      text-align: center;
      padding: 0.875rem 0 6.125rem;
    }

    .nowLogin {
      padding: 0 1.875rem;
      margin-bottom: 0.9375rem;

      > div {
        width: 100%;
        height: 2.6875rem;
        background: linear-gradient(180deg, #ffdb67 0%, #f8c007 100%);
        border-radius: 1.375rem;
        display: flex;
        align-items: center;
        justify-content: center;

        > p {
          font-size: 0.9375rem;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #0c0b0b;
        }
      }
    }
  }

  .index-view-top {
    height: 3.625rem;
    padding: 0 0.9375rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      font-size: 1.125rem;
      font-family: PingFang SC-Bold, PingFang SC;
      font-weight: bold;
      color: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/user/asset.vue